<div
  class="container-fluid p-0 d-flex flex-column overflow-hidden"
  style="height: calc(100% - 70px)"
>
  <div class="clearfix m-0 h-100">
    <div id="media-body" class="p-0 h-100">
      <div class="row m-0 h-100">
        <ngx-simplebar id="scroll" class="h-100" #scrollRef>
          <div class="row m-0 flex-grow-1">
            <div class="col h-100">
              <div class="media-grid">
                <ng-container *ngFor="let image of mediaData; let i = index">
                  <label
                    class="media-cell position-relative"
                    [for]="data?.id + image?.id"
                    [id]="i"
                  >
                    <input
                      #checkbox
                      type="checkbox"
                      class="hidden-checkbox"
                      [id]="data?.id + image?.id"
                      (change)="addImages(image, checkbox?.checked)"
                      [checked]="isMediaSelected(image)"
                    />
                    <span class="custom-checkbox"></span>
                    <img
                      *ngIf="!image?.id?.endsWith('.mp4') && (data.media_type == 'image' || data.media_type == 'gif')"
                      [src]="image?.permanentUrl || image?.url"
                      [alt]="image?.filename"
                    />
                    <video
                      *ngIf="image?.id?.endsWith('.mp4') && (data.media_type == 'video' || data.media_type == 'gif')"
                      [src]="image?.permanentUrl || image?.url"
                      controls
                      muted
                    ></video>
                    <img
                      *ngIf="data.media_type == 'audio'"
                      src="assets/images/media-optical-audio.svg"
                      [alt]="image?.filename"
                    />
                    <audio controls class="audio-player" *ngIf="data.media_type == 'audio'">
                      <source [src]="image?.permanentUrl || image?.url" type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                    <div
                      *ngIf="image?.status === 'upload'"
                      class="position-absolute top-0 bottom-0 start-0 end-0 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center rounded"
                    >
                      <div role="status" class="spinner-border text-white">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </label>
                </ng-container>
              </div>
              <!-- <div
                class="d-grid gap3"
                style="
                  grid-template-columns: repeat(
                    auto-fill,
                    minmax(8.125rem, 1fr)
                  );
                "
              >
                <ng-container *ngFor="let image of mediaData; let i = index">
                  <label
                    [for]="data?.id + image?.id"
                    class="p-2 rounded curser-pointer m-0 media-hover d-flex flex-column"
                    [class.media-selected]="isMediaSelected(image)"
                    [id]="i"
                  >
                    <div class="row flex-grow-1">
                      <div
                        class="mx-auto col-8 d-flex justify-content-center p-0 h-100"
                        style="max-height: 8.125rem"
                      >
                        <div
                          class="position-relative d-flex w-100 p-1 rounded border bg-white"
                        >
                          <input
                            #checkbox
                            type="checkbox"
                            [id]="data?.id + image?.id"
                            (change)="addImages(image, checkbox?.checked)"
                            [checked]="isMediaSelected(image)"
                            class="form-check-input position-absolute mt-2 ms-2"
                          />
                          <img
                            class="object-fit-contain border rounded w-100"
                            [src]="image?.permanentUrl || image?.url"
                            [alt]="image?.filename"
                            style="
                              max-height: 100%;
                              max-width: 100%;
                              background-color: rgba(241, 241, 241, 1);
                            "
                          />
                          <button
                            class="btn btn-primary btn-sm position-absolute"
                            style="bottom: 0.5rem; right: 0.5rem"
                            (click)="openSlaider($event, image, i)"
                          >
                            <i class="far fa-eye"></i>
                          </button>
                          <div
                            *ngIf="image?.status === 'upload'"
                            class="position-absolute top-0 bottom-0 start-0 end-0 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center rounded"
                          >
                            <div
                              role="status"
                              class="spinner-border text-white"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2 text-center text-truncate">
                      {{ image?.filename }}
                    </div>
                    <div class="mt-2 text-center text-truncate">{{ image?.type }}</div>
                  </label>
                </ng-container>
              </div> -->
            </div>
          </div>
        </ngx-simplebar>
        <!-- <div
          id="carouselExampleCaptionDiv"
          class="w-50 animate-right-out d-flex flex-column"
          style="background-color: rgba(241, 241, 241, 1)"
        >
          <div
            class="d-flex align-items-center justify-content-between p-3 fw-semibold"
          >
            Preview
            <button
              class="btn btn-close"
              (click)="closeSlaider($event)"
            ></button>
          </div>
          <carousel
            id="carouselExampleCaption"
            [interval]="0"
            [(activeSlide)]="imageIndex"
            [showIndicators]="false"
            class="carousel slide w-100 h-100"
          >
            <div class="carousel-inner w-100 h-100" role="listbox">
              <slide
                class="carousel-item h-100"
                *ngFor="let image of mediaPreviewData"
              >
                <img
                  [src]="image?.permanentUrl || image?.url"
                  [alt]="image?.filename"
                  class="object-fit-contain border rounded"
                  style="max-width: 100%; max-height: 100%"
                />
              </slide>
            </div>
          </carousel>
        </div> -->
      </div>
    </div>
  </div>
</div>

<div class="modal-footer pe-4 d-flex align-items-center">
  <div class="d-flex align-items-center justify-content-start me-auto">
    <div>
      <div class="ps-0 d-flex justify-content-end">
        <!-- <md-outlined-button id="users_pagination_selector_back" (click)="backPage()">
                  <i slot="icon" class="mdi mdi-chevron-left font-size-18"></i>
                  <p class="mb-0">{{ "GENERALS.PREV" | translate }}</p>
                </md-outlined-button> -->
        <button
          type="button"
          class="btn btn-soft-info waves-effect waves-light"
          id="pagination_back"
          (click)="backPage()"
        >
          {{ "GENERALS.PREV" | translate }}
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center mx-2">
      <p class="avatar-xs invisible mb-0" id="usersShowPageNumberSelector">
        <span
          class="avatar-title rounded-circle primary-text bg-transparent border border-outline"
        >
          {{ currentPage }}
        </span>
      </p>
    </div>
    <div>
      <div class="d-flex justify-content-start ps-0">
        <!-- <md-outlined-button
                  trailing-icon
                  id="users_pagination_selector_next"
                  (click)="nextPage()"
                >
                  <span>{{ "GENERALS.NEXT" | translate }}</span>
                  <i slot="icon" class="mdi mdi-chevron-right font-size-18"></i>
                </md-outlined-button> -->

        <button
          type="button"
          class="btn btn-soft-info waves-effect waves-light"
          id="pagination_next"
          (click)="nextPage()"
        >
          {{ "GENERALS.NEXT" | translate }}
        </button>
      </div>
    </div>
  </div>
  <button class="btn btn-danger w-md rounded-pill me-2" (click)="cancelMedia()">
    Cancel
  </button>
  <button
    class="btn btn-success w-md rounded-pill"
    [disabled]="mediaSelectedImages.length === 0"
    (click)="useSelected()"
  >
    Done
  </button>
</div>
